(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["euphoria-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initRail(root) {
    if (!root || root.dataset.railReady === '1') return;
    var track = root.querySelector('.euphoria-rail__track');
    var prev = root.querySelector('.euphoria-rail__arrow--prev');
    var next = root.querySelector('.euphoria-rail__arrow--next');
    if (!track) return;
    root.dataset.railReady = '1';

    var isRtl = function () { return getComputedStyle(track).direction === 'rtl'; };
    var pageWidth = function () {
      var item = track.querySelector('.euphoria-rail__item');
      if (!item) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      var w = item.getBoundingClientRect().width + gap;
      var perView = Math.max(1, Math.floor((track.clientWidth + gap) / w));
      return w * perView;
    };
    var go = function (dir) {
      track.scrollBy({ left: dir * pageWidth() * (isRtl() ? -1 : 1), behavior: 'smooth' });
    };
    var update = function () {
      var max = track.scrollWidth - track.clientWidth;
      var pos = Math.abs(track.scrollLeft);
      root.classList.toggle('is-scrollable', max > 2);
      if (prev) prev.disabled = pos <= 1;
      if (next) next.disabled = pos >= max - 1;
    };

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', update, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { go(isRtl() ? -1 : 1); e.preventDefault(); }
      if (e.key === 'ArrowLeft') { go(isRtl() ? 1 : -1); e.preventDefault(); }
    });
    window.addEventListener('resize', update);
    update();
    setTimeout(update, 600);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.euphoria-rail').forEach(initRail);
  }
  // exposed so other Euphoria sections (e.g. euphoria-related, loaded async) can init a rail
  window.EuphoriaRail = { init: initRail, initAll: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.euphoria-rail');
    if (root) { root.dataset.railReady = ''; initRail(root); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["euphoria-related"] && !Shopify.designMode) return;
  try {
    
/* Rail runtime (same as euphoria-products). Shopify only ships compiled_assets/scripts.js on pages that
   render a section with a javascript tag, so the product page needs its own copy. Guarded: defined once. */
(function () {
  if (window.EuphoriaRail) return;
  function initRail(root) {
    if (!root || root.dataset.railReady === '1') return;
    var track = root.querySelector('.euphoria-rail__track');
    var prev = root.querySelector('.euphoria-rail__arrow--prev');
    var next = root.querySelector('.euphoria-rail__arrow--next');
    if (!track) return;
    root.dataset.railReady = '1';
    var isRtl = function () { return getComputedStyle(track).direction === 'rtl'; };
    var pageWidth = function () {
      var item = track.querySelector('.euphoria-rail__item');
      if (!item) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      var w = item.getBoundingClientRect().width + gap;
      var perView = Math.max(1, Math.floor((track.clientWidth + gap) / w));
      return w * perView;
    };
    var go = function (dir) { track.scrollBy({ left: dir * pageWidth() * (isRtl() ? -1 : 1), behavior: 'smooth' }); };
    var update = function () {
      var max = track.scrollWidth - track.clientWidth;
      var pos = Math.abs(track.scrollLeft);
      root.classList.toggle('is-scrollable', max > 2);
      if (prev) prev.disabled = pos <= 1;
      if (next) next.disabled = pos >= max - 1;
    };
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', update, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { go(isRtl() ? -1 : 1); e.preventDefault(); }
      if (e.key === 'ArrowLeft') { go(isRtl() ? 1 : -1); e.preventDefault(); }
    });
    window.addEventListener('resize', update);
    update();
    setTimeout(update, 600);
  }
  function initAll(scope) { (scope || document).querySelectorAll('.euphoria-rail').forEach(initRail); }
  window.EuphoriaRail = { init: initRail, initAll: initAll };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { initAll(); }); } else { initAll(); }
  document.addEventListener('shopify:section:load', function (e) { var root = e.target.querySelector('.euphoria-rail'); if (root) { root.dataset.railReady = ''; initRail(root); } });
})();

  } catch(e) { console.error(e); }
})();
})();
